import translationEN from '../../../assets/locales/en/translation.json';
import translationFR from "../../../assets/locales/fr/translation.json";
import translationPL from "../../../assets/locales/pl/translation.json";

import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import { enqueueSnackbar } from 'notistack';
import {State} from './CardGridState'

import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";

import 'font-awesome/css/font-awesome.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap';
import 'flatpickr/dist/flatpickr.min.css';

import '../../../components/grid/styles.scss';
import '../../../components/grid/slickgrid.scss';
import '../../../layouts/gridlayout.css'
import i18next, { TFunction } from 'i18next';

import NoteService from "../../../services/contractor/notes.service";
import ContactService from "../../../services/contractor/contacts.service";
import DatachangeService from "../../../services/datachange/datachange.service";
import { ColorEditor } from '../../../components/grid/CustomEditors/ColorEditor';
import $ from 'jquery'; 

import {
   SlickgridReact, FieldType, Filters,
   GridOption,
  Column, Formatter, Formatters,
  Editors, EditCommand, 
  CompositeEditorModalType, OnCompositeEditorChangeEventArgs, CompositeEditorSelection,
  InputEditor,
  SlickGrid,
  OnAddNewRowEventArgs,
  EditorValidator,
  CurrentSorter,
  EmitterType,
  Pagination,
  LongTextEditorOption,
} from 'slickgrid-react';

import { ExcelExportService } from '@slickgrid-universal/excel-export';
import { OdataOption, OdataServiceApi } from '@slickgrid-universal/odata';


import CardGrid, {CardGridProps} from './CardGridComponent';
import { TextOperators } from '../../../components/grid/CustomFilters/TextFilter';
import { SlickCustomTooltip } from '@slickgrid-universal/custom-tooltip-plugin';
import authService from '../../../services/auth/auth.service';
import { LookupCollection, LookupData } from '../../../components/grid/GridUtils';

import { withTranslation } from 'react-i18next';
import { InputAdornment, ListItemText, MenuItem, Select, TextField } from '@mui/material';
import { useLocation } from 'react-router-dom';
import { MouseEventHandler, useState } from 'react';
import BorderSpinner from '../../../components/Layout/spinner';
import { ChangeTypes } from '../../../services/datachange/datachange.service';
import notesService from '../../../services/contractor/notes.service';
import { Height } from '@mui/icons-material';

const ContrastColor = require('contrast-color');


const location = 'contractor'
const LOCAL_STORAGE_SEARCH = authService.getCurrentUser()?.shrt + '_crm-' + location + '-search' 


const loc = 'contractorcard'
const LOCAL_STORAGE_ACTIVE_TAB = authService.getCurrentUser()?.shrt + '_crm-' + location + '-tabindex' 

const resources = {
  en: {
    translation: translationEN
  },
  fr: {
    translation: translationFR
  },
  pl: {
    translation: translationPL
  }
};


class ContractorGrids extends CardGrid {
    title = 'Karta kontrahenta';
    subTitle = 'Zarządzanie kontrahentem'
    lastApiCall : Date;
    constructor(public readonly props: CardGridProps) {
    super(props);  
    this.lastApiCall = new Date(0)
 }

 getNotelookups(){
  return NoteService.getNotelookups().then(response => {

        let tmp1: LookupCollection[] = []
        if ((response.data) && (Array.isArray(response.data))){
            tmp1  = response.data
        }
        this.setState((state: State) => ({
          ...state,
          lookupDataNote : tmp1
        }),  () => {
            this.defineGrids();          

          }
        );

   
  }
     
  ).catch(
    () => {
      let tmp : LookupData[] = [];
      this.setState((state: State) => ({
            ...state,
            alertError: "Nie wszystkie dane zostały poprawnie zaczytane - odśwież stronę!"
      }));
      return tmp;
    }
  )
}

componentDidMount() {
 window.addEventListener("resize",((e: any) =>{
  var activeTabIndexStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TAB) || "1"
  var activeTabIndex = parseInt(activeTabIndexStr)
  if (activeTabIndex ==1){ 
    setTimeout(() => { this.noteGrid.resizerService.resizeGrid(); }, 1000);
  }else if (activeTabIndex ==2){
    setTimeout(() => { this.contactGrid.resizerService.resizeGrid(); }, 1000);
  }else if (activeTabIndex ==5){
    setTimeout(() => { this.changeGrid.resizerService.resizeGrid(); }, 1000);
  }
    
 }).bind(this));

 //this.defineGrids()
 this.getNotelookups()

    i18next.init({
      lng: 'pl',
      debug: false,
      resources: resources
    }, (err, t) => {
      i18next.changeLanguage("pl"); 
      
    });

}

defineGrids() {
    var presets_note = JSON.parse(localStorage[this.storage_note_key] || null);
    var presets_contact = JSON.parse(localStorage[this.storage_contact_key] || null);
    var presets_change = JSON.parse(localStorage[this.storage_change_key] || null);
    if (presets_note){
      var new_note_sorters = presets_note.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
     
      presets_note.pagination.pageNumber = 1

      presets_note.sorters = new_note_sorters;
    }

    if (presets_contact){
      var new_contact_sorters = presets_contact.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets_contact.pagination.pageNumber = 1
      presets_contact.sorters = new_contact_sorters;
    }
    if (presets_change){
      var new_change_sorters = presets_change.sorters.map((element: CurrentSorter) => {
        element.columnId = (element.columnId as string).toLowerCase();
        return element;
      });
      presets_change.pagination.pageNumber = 1
      presets_change.sorters = new_change_sorters;
    }
   
    var activeTabIndexStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TAB) || "1"
    var activeTabIndex = parseInt(activeTabIndexStr)

    var gridContactOptions : GridOption | undefined =  undefined;
    var columnContactDefinitions : Column[]= [];
    var gridNoteOptions : GridOption | undefined =  undefined;
    var columnNoteDefinitions : Column[]= [];
    var gridChangeOptions : GridOption | undefined =  undefined;
    var columnChangeDefinitions : Column[]= [];
    
    if (activeTabIndex >=1 && activeTabIndex<=5){

      if (activeTabIndex==1){  
        var gridNoteOptions =  this.getCustomGridDefinition("note");
        var columnNoteDefinitions = this.getNoteColumnDefinitions();
        (gridNoteOptions as GridOption).presets = presets_note
      

      }else if (activeTabIndex==2){
        var gridContactOptions =  this.getCustomGridDefinition("contact");
        var columnContactDefinitions = this.getContactColumnDefinitions();
        (gridContactOptions as GridOption).presets = presets_contact
      }else if (activeTabIndex==5){
        var gridChangeOptions =  this.getCustomGridDefinition("change");
        var columnChangeDefinitions = this.getChangeColumnDefinitions();
        (gridChangeOptions as GridOption).presets = presets_change
      }
      
    }

    this.setState((state: State) => ({
      ...state,
      notes_gridOptions:gridNoteOptions,
      notes_columnDefinitions:columnNoteDefinitions,
      contacts_gridOptions:gridContactOptions,
      contacts_columnDefinitions:columnContactDefinitions,
      changes_gridOptions:gridChangeOptions,
      changes_columnDefinitions:columnChangeDefinitions,
    }));

}

componentDidUpdate(PrevProps: any, prevState: State){
    if(this.state.alertErrorMsg !== prevState.alertErrorMsg){
        if (this.state.alertErrorMsg){
          //alert(this.state.alertErrorMsg)
        }
    }   
}


getCustomGridDefinition(grid_name:string): GridOption | undefined {    
      var tmp = super.getGridDefinition(this.state);
      var container = grid_name + '-container'  
      var aEdit=true;
      var editorInstance = this.compositeEditorInstanceNote
      if (grid_name=='note'){
        aEdit = this.state.isAutoEditNote
        editorInstance = this.compositeEditorInstanceNote
      }else if  (grid_name=='contact'){
        aEdit = this.state.isAutoEditContact
        editorInstance = this.compositeEditorInstanceContact
      }else if  (grid_name=='change'){
        aEdit = this.state.isAutoEditChange
        editorInstance = this.compositeEditorInstanceChange
      }
      tmp = {
        ...tmp,
        autoEdit: aEdit,
        enableTranslate: true,
        i18n: i18next,
        autoResize: {
          container: container,
          rightPadding: 10
        },
       
        externalResources: [new ExcelExportService(), editorInstance, new SlickCustomTooltip()],
        
        editCommandHandler: (_item:any, _column:Column<any>, editCommand:EditCommand) => {
          var data = _item
          
          if (grid_name=="note"){
            this._commandQueueNote.push(editCommand);
            editCommand.execute();
            this.editNoteApiCall(data);
          }else if  (grid_name=="contact"){
            this._commandQueueContact.push(editCommand);
            editCommand.execute();
            this.editContactApiCall(data);
          }
          
        },
        presets: {},
        
        backendServiceApi: {
          ...tmp.backendServiceApi,
          onError: (error: Error) => {
              this.setState((state: State, props: CardGridProps) => ({
                ...state,
                alertError: "Błąd połączenia!"
              }));  
          },
          preProcess: () => {
            this.setState((state: State) => ({ ...state, errorStatus: '' }));
            if (grid_name=="note"){
              this.displayNoteSpinner(true);
            }else if  (grid_name=="contact"){
              this.displayContactSpinner(true);
            }else if  (grid_name=="change"){
              this.displayChangeSpinner(true);
            }
          },
          process: (query) => {   
              query=query + "&$contractor_id=" + this.contractor_id
            if (grid_name=="note"){         
              return this.getNoteApiCall(query)
            }else if  (grid_name=="contact"){
              return this.getContactApiCall(query)
            }else if  (grid_name=="change"){
              return this.getChangeApiCall(query)
            }
          },
          postProcess: (response) => {
            if (grid_name=="note"){ 
              if (new Date(response.metrics.startTime) > this.lastApiCall){
                this.lastApiCall = new Date(response.metrics.startTime)
                this.setState(
                  (state: State) => ({ ...state, metrics: response.metrics }),
                  () => this.postProcessNoteCallback(response)
                );
              }
             
              this.displayNoteSpinner(false);
            }else if  (grid_name=="contact"){
              if (new Date(response.metrics.startTime) > this.lastApiCall){
                this.lastApiCall = new Date(response.metrics.startTime)
                this.setState(
                  (state: State) => ({ ...state, metrics: response.metrics }),
                  () => this.postProcessContactCallback(response)
                );
              }
             
              this.displayContactSpinner(false);
            }else if  (grid_name=="change"){
              if (new Date(response.metrics.startTime) > this.lastApiCall){
                this.lastApiCall = new Date(response.metrics.startTime)
                this.setState(
                  (state: State) => ({ ...state, metrics: response.metrics }),
                  () => this.postProcessChangeCallback(response)
                );
              }
              
              this.displayChangeSpinner(false);
            }
            
          },
        } as OdataServiceApi
      }
    return tmp;
  }


  postProcessNoteCallback(data: any) {
    let totalItemCount: number = data['total']; // you can use "totalRecordCount" or any name or "odata.count" when "enableCount" is set
    var activeTabIndexStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TAB) || "1"
    var activeTabIndex = parseInt(activeTabIndexStr)
    if (activeTabIndex ==1){
    this.setState((state: State) => ({
      ...state,
      notePaginationOptions: { ...state.notes_gridOptions!.pagination, totalItems: totalItemCount } as Pagination,
      notes_dataset: data['items'],
      noteMetrics: { ...state.noteMetrics, totalItemCount }
    }));
    this.noteGrid.eventPubSubService?.publish('onPaginationOptionsChanged', { ...this.state.notes_gridOptions!.pagination, totalItems: totalItemCount } as Pagination, 1);
  }
  }

  postProcessContactCallback(data: any) {
  let totalItemCount: number = data['total']; // you can use "totalRecordCount" or any name or "odata.count" when "enableCount" is set
  var activeTabIndexStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TAB) || "1"
    var activeTabIndex = parseInt(activeTabIndexStr)
    if (activeTabIndex ==2){
  this.setState((state: State) => ({
    ...state,
    contactPaginationOptions: { ...state.contacts_gridOptions!.pagination, totalItems: totalItemCount } as Pagination,
    contacts_dataset: data['items'],
    contactMetrics: { ...state.contactMetrics, totalItemCount }
  }));
  this.contactGrid.eventPubSubService?.publish('onPaginationOptionsChanged', { ...this.state.contacts_gridOptions!.pagination, totalItems: totalItemCount } as Pagination, 1);
    }  
}

  postProcessChangeCallback(data: any) {
    let totalItemCount: number = data['total']; // you can use "totalRecordCount" or any name or "odata.count" when "enableCount" is set
    var activeTabIndexStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TAB) || "1"
    var activeTabIndex = parseInt(activeTabIndexStr)
    if (activeTabIndex ==5){
    this.setState((state: State) => ({
      ...state,
      changePaginationOptions: { ...state.changes_gridOptions!.pagination, totalItems: totalItemCount } as Pagination,
      changes_dataset: data['items'],
      changesMetrics: { ...state.changeMetrics, totalItemCount }
    }));
    this.changeGrid.eventPubSubService?.publish('onPaginationOptionsChanged', { ...this.state.changes_gridOptions!.pagination, totalItems: totalItemCount } as Pagination, 1);
    } 
  }

  onCellValidationError(_e: Event, args: any) {
      if (args.validationResults) {
        this.setState((state: State, props: CardGridProps) => ({
          ...state,
          alertWarning: args.validationResults.msg
        }));
      }
  }



  userFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
      var s=""
      if ( dataContext.shortcut !=null){   
          s=  '<a class="slickRowLink" href="/users">' +
              '<span style="background-color:' + dataContext.color + '!important; color: ' + new ContrastColor(dataContext.color) + '" class="gavatar_m" >' + dataContext.shortcut +'</span>' + '</a>'
      }
      return s;
  };

  noteValidator :EditorValidator = (value: any) => {
    let ready=false
    if (value === null || value === undefined || !value.length) {
      return { valid: false, msg: 'To pole jest wymagane' };
    }else{
      return {
        valid: true,
        msg: '',
      }
    }
  }

  maxLen100Validator :EditorValidator = (value: any) => {
    let ready=false
    if (value === null || value === undefined || !value.length) {
      return { valid: true, msg: '' };
    }else if (value.length > 100){
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
      }
    }else{
      return {
        valid: true,
        msg: '',
      }
    }
  }

  requiredNameValidator :EditorValidator = (value: any) => {
    let ready=false
    if (value === null || value === undefined || !value.length) {
      return {
        valid: false,
        msg: 'To pole jest wymagane',
       }
    }else if (value.length > 255){
      return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 255 znaków',
      }
    }else{
      return {
        valid: true,
        msg: '',
      }
    }
  }

  phoneValidator: EditorValidator = (value: any) => {

    if (value.length>100) {
    return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
    };
    }else if (/[a-zA-Z]+/.test(value)){
    return { valid: false, msg: 'Numer telefonu nie może zawierać liter [a-z A-Z]' };
    }
    return { valid: true, msg: '' };
};

emailValidator: EditorValidator = (value: any) => {
  if (!(value === null || value === undefined || !value.length)) {
    if (value.length>100) {
        return {
        valid: false,
        msg: 'To pole przyjmuje maksymalnie 100 znaków',
        };
    }else if (!/^[\w-.]+@([\w-]+\.)+[\w-]{2,8}$/.test(value)){
        return { valid: false, msg: 'Nieprawidłowy format adresu e-mail' };
    }
  }
  return { valid: true, msg: '' };
};


getNoteColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = []; 
    let data_notedefs : LookupData[] = []

    this.state.lookupDataNote?.forEach((item) => {
      if (item.name === 'notedefs'){
        data_notedefs = item.data; 
      } 
    })
    //if (authService.isAdmin()){
      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteFormatter.bind(this) as Formatter
          },    
        }
      );
    //}

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'created', name: 'Data', field: 'created', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100,
        width:150        
      },
      {
        id: 'notedef_name', name: 'Typ notatki', field: 'notedef_name', sortable: true, filterable: true,
        type: FieldType.string,
        filter: {model: Filters.multipleSelect, collection:data_notedefs, compoundOperatorList: TextOperators},
        editor: {model: Editors.singleSelect,
          collection: data_notedefs,
          massUpdate: true,
          compositeEditorFormOrder : 1,
          validator : this.noteValidator,
        },
        
        minWidth:100,
        width:150 
      },
      {
        id: 'shortcut', name: 'Użytkownik', field: 'shortcut', sortable: true, filterable: true,
        type: FieldType.string,
        cssClass: "column-centered",
        formatter:this.userFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:50
             
      },
      {
        id: 'description', name: 'Notatka', field: 'description', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.longText,
          //validator : this.Validators.nameValidator,
          compositeEditorFormOrder : 2,
          validator : this.noteValidator,
          editorOptions: {
            cols: 45,
            rows: 3,
            
          } as LongTextEditorOption,
          
        },
        //hidden:false,
        minWidth:100
             
      },
        
    );

    tmp = this.customizeHeaderMenu(tmp, this.columnsize_note_key)

    return tmp
  }


  getContactColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = []; 
    let data_notedefs : string[] = []

      tmp.push(
        {
          id: 'delete', field: 'id',
          excludeFromColumnPicker: true, excludeFromGridMenu: true,excludeFromHeaderMenu: true,
          formatter: Formatters.icon, params: { iconCssClass: 'fa fa-trash pointer' }, minWidth: 30, maxWidth: 30,  
          customTooltip: {
            formatter:  this.deleteFormatter.bind(this) as Formatter
          },    
        }
      );
 

    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'position', name: 'Stanowisko', field: 'position', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.maxLen100Validator
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'name', name: 'Nazwa', field: 'name', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.requiredNameValidator
          
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'phone', name: 'Telefon', field: 'phone', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.phoneValidator
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'mail', name: 'E-mail z NL', field: 'mail', sortable: true, filterable: true,
        type: FieldType.string,
        excludeFromColumnPicker: true,
        filter: {model: Filters.compoundInput, compoundOperatorList: TextOperators},       
        editor: {model: Editors.text,
          compositeEditorFormOrder : 2,
          validator : this.emailValidator
          
        },
        hidden:false,
        minWidth:100      
      },
      {
        id: 'unsub_eml', name: 'Email rezygnacja z NL', field: 'unsub_eml', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
      {
        id: 'unsub_tel', name: 'Telefon rezygnacja z NL', field: 'unsub_tel', sortable: true, filterable: true,
        type: FieldType.boolean,
        formatter: Formatters.checkmark,
        filter: {
          model: Filters.singleSelect,
          collection: [
            { value: '', label: '' },
            { value: 1, label: 'Tak' },
            { value: 0, label: 'Nie' },
          ],
        },
        editor: {model: Editors.checkbox,
          compositeEditorFormOrder : 14,
        },
        
        minWidth:50
      },
     
      {
        id: 'modified', name: 'Data edycji', field: 'modified', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },
      {
        id: 'created', name: 'Data utworzenia', field: 'created', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100   
      },
     
         
    );

    tmp = this.customizeHeaderMenu(tmp, this.columnsize_contact_key)

    return tmp
  }

  modifierFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
		var s=""
    if ( dataContext.modifier_shortcut !=null){   
         s=  '<a class="slickRowLink" href="/users">' +
            '<span style="backgroundColor:' + dataContext.modifier_color + '!important; color: ' + new ContrastColor(dataContext.modifier_color) + '" class="gavatar_m" >' + dataContext.modifier_shortcut +'</span>' + '</a>'
		}
    return s;
  };
  
  rownameFormatter = function (row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
		var s=""
    if ( dataContext.table_name =='contractors'){  
			s ="<a class='slickRowLink' href='/contractors/edit/" + dataContext.table_id + "' >" + dataContext.row_name + "</a>";   
		}else if ( dataContext.table_name =='contactpersons'){ 
		   s ="<a class='slickRowLink' href='/contacts/edit/" + dataContext.table_id + "' >" + dataContext.row_name + "</a>";   
		}else if ( dataContext.table_name =='notes'){  
			//s ="<a class='slickRowLink' href='" +  "<?= $this->Url->build(['controller'=>'contractors','action'=>'edit'])?>/" + dataContext.contractor_id + "' target=_blank>" + //dataContext.contractor_name + "</a>";   
			if ( dataContext.row_name !=null){
			s ="<a class='slickRowLink' href='/contractors/edit/'" + dataContext.note_contractor_id + "' >" + dataContext.row_name + "</a>";   
			}else{
				s ="";
			}
    }else if ( dataContext.table_name =='users'){  
      s =value;    
		}else{
			s =value;
		}
        return s;
    };

  getChangeColumnDefinitions(): Column[] {
    super.getColumnDefinitions()
    let tmp : Column[] = []; 
    
    tmp.push(
      {
        id: 'row_no', name: 'Lp.', field: 'row_no', sortable: false, filterable: false,
        type: FieldType.integer,
        minWidth:30 ,
        maxWidth:50    
      },
      {
        id: 'changedate', name: 'Data modyfikacji', field: 'changedate', sortable: true, filterable: true,
        type: FieldType.dateTimeIso,
        formatter:Formatters.dateTimeIso,
        filter: {model: Filters.dateRange, filterOptions:{enableTime:false}},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'changetype_name', name: 'Typ modyfikacji', field: 'changetype_name', sortable: true, filterable: true,
        type: FieldType.string,
        //formatter:this.taskTranslateFormatter,
        filter: { 
          collection: ChangeTypes,
          model: Filters.multipleSelect,
          searchTerms: [],
          queryField: "changetype_id"
        },        
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'modifier_shortcut', name: 'Zmiana przez', field: 'modifier_shortcut', sortable: true, filterable: true,
        type: FieldType.string,
        cssClass: "column-centered",
        formatter:this.modifierFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:50
             
      },
      {
        id: 'table_caption', name: 'Tabela', field: 'table_caption', sortable: true, filterable: true,
        type: FieldType.string,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'column_caption', name: 'Kolumna', field: 'column_caption', sortable: true, filterable: true,
        type: FieldType.string,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'row_name', name: 'Dotyczy', field: 'row_name', sortable: true, filterable: true,
        type: FieldType.string,
        formatter:this.rownameFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:100
             
      },
      {
        id: 'description', name: 'Opis', field: 'description', sortable: true, filterable: true,
        type: FieldType.string,
        //formatter:this.taskTranslateFormatter,
        filter: {model: Filters.inputText,},           
        hidden:false,
        minWidth:100
             
      },

    )
     
    tmp = this.customizeHeaderMenu(tmp, this.columnsize_change_key)

    return tmp
  }
  

  deleteFormatter(row: number, cell: number, value: any, column: Column, dataContext: any, grid: SlickGrid) {
    const tooltipTitle = 'Usuń';
    return '<div class="header-tooltip-title">${tooltipTitle}</div>'
  }

  getNoteApiCall(query: string) {
    //TEST Notatek ADAMADAM
    //console.log(query)
    return NoteService.getNotes(query)
  }
  getContactApiCall(query: string) {
    return ContactService.getContacts(query)
  }

  getChangeApiCall(query: string) {
    return DatachangeService.getdatachanges(query)
  }

  editNoteApiCall(data: any) {   
    if ((data.date == '') || ((data.date == null))){
      // var tmpDate = data.contactdate.match("[0-9]{4}([\-/ \.])[0-9]{2}[\-/ \.][0-9]{2}");
      //data.contactdate = tmpDate[0] + 'T00:00:00'
      data.date=0;
     }
    NoteService.editNote(data).then(
      () =>  {
          if (data.date==0){
            data.date=''
          }

          this.noteGrid.slickGrid.invalidate()
      }
      ).catch(
         () => {
          try{
            this._commandQueueNote.pop()?.undo()
            this.setState((state: State, props: CardGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }

  editContactApiCall(data: any) {   
    ContactService.editContact(data).then(
      ()=>{
        this.contactGrid.slickGrid.invalidate()
      }
      ).catch(
         () => {
          try{
            this._commandQueueContact.pop()?.undo()
            this.setState((state: State, props: CardGridProps) => ({
              ...state,
              alertError: "Błąd edycji danych"
            }));
          }catch{

          }
        }
      )
  }


  sortCollectionDescending(collection: any[]) {
    return collection.sort((item1, item2) => item1.value - item2.value);
  }

  openNoteCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.noteGrid.slickGrid.getEditorLock().isActive() && !this.noteGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowej notatki';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie notatki';
          break;
        case 'edit':
          var selecttedcount =  this.noteGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych notatek (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja notatki';
          }
          break;
      }
      var modalColumns = this.noteGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.noteGrid.slickGrid.getSelectedRows() && (this.noteGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstanceNote?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',

          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.noteGrid.slickGrid.getSelectedRows() && (this.noteGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jedną notatkę do edycji!');
      }else{
        alert('Nie wybrano notatki do edycji!');
      }
    }else{
        this.compositeEditorInstanceNote?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
            
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null, contractor_id:this.contractor_id }
              NoteService.addNote(tmp).then(
                  () => {
                    this.noteGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error: any) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: CardGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: CardGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania notaki"
                        }));
                      }
                      
                      var tmp = this.noteGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.noteGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }

  openContactCompositeModal(modalType: CompositeEditorModalType) {
    let modalTitle = '';
    if (this.contactGrid.slickGrid.getEditorLock().isActive() && !this.contactGrid.slickGrid.getEditorLock().commitCurrentEdit()) {
      return;
    }
      switch (modalType) {
        case 'create':
          modalTitle = 'Dodawanie nowego kontaktu';
          break;
        case 'clone':
          modalTitle = 'Kopiowanie kontaktu';
          break;
        case 'edit':
          var selecttedcount =  this.contactGrid.slickGrid.getSelectedRows();
          if (selecttedcount.length > 1){
            modalTitle = 'Edycja wybranych kontatktów (' + selecttedcount + ')';
            modalType = 'mass-selection';
          }else{
            modalTitle = 'Edycja kontaktu';
          }
          break;
      }
      var modalColumns = this.contactGrid.slickGrid.getColumns(). filter(col => col.editor);

    if (modalType==='edit'){
      if (this.contactGrid.slickGrid.getSelectedRows() && (this.contactGrid.slickGrid.getSelectedRows().length===1)){
        this.compositeEditorInstanceContact?.openDetails({
          headerTitle: modalTitle,
          modalType,
          insertOptions: { highlightRow: false }, 
          showFormResetButton: true,
          resetFormButtonIconCssClass: 'fa fa-undo',
          
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
        });
      }else if (this.contactGrid.slickGrid.getSelectedRows() && (this.contactGrid.slickGrid.getSelectedRows().length>1)){
        alert('Wybież jeden kontakt do edycji!');
      }else{
        alert('Nie wybrano kontaktu do edycji!');
      }
    }else{
        this.compositeEditorInstanceContact?.openDetails({
            headerTitle: modalTitle,
            modalType,
            insertOptions: { highlightRow: false }, 
            showFormResetButton: true,
            resetFormButtonIconCssClass: 'fa fa-undo',
          
            
          onClose: () => Promise.resolve(window.confirm('Istnieją niezapisane zmiany, czy na pewno chcesz wyjść bez zapisywania zmian?')),
          onError: (error) => alert(error.message),
          onSave: (formValues, _selection: CompositeEditorSelection, dataContext) => {
            if (_selection.gridRowIndexes.length===0){
              let tmp = {...dataContext, id:null, contractor_id : this.contractor_id}
              ContactService.addContact(tmp).then(
                  () => {
                    this.contactGrid.filterService.updateFilters([])
                  }
                ).catch(
                  (error: any) => {
                    try{   
                      if (error && error.response && error.response.data && error.response.data.detail){
                        this.setState((state: State, props: CardGridProps) => ({
                          ...state,
                          alertError: "Błąd: " + error.response.data.detail
                        }));
                      }else{          
                        this.setState((state: State, props: CardGridProps) => ({
                          ...state,
                          alertError: "Błąd podczas dodawania kontaktu"
                        }));
                      }
                      
                      var tmp = this.contactGrid.slickGrid.getData().getItems()
                      tmp.splice(0,1);
                      
                      this.contactGrid.slickGrid.getData().setItems(tmp)
                    }catch{
          
                    }
                  }
                )   
            }
          const serverResponseDelay = 50;
          return new Promise(resolve => setTimeout(() => resolve(true), serverResponseDelay));
        }
      });
    }
  }


    
  onNoteCellClicked(_e: Event, args: any) {
    const metadata = this.noteGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie notatki?')) {
        NoteService.deleteNote(metadata.dataContext.id).then(
          () => {
            this.noteGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: CardGridProps) => ({
              ...state,
              alertInfo: `Usunięto notatkę`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: CardGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu notatki`,
            }));
          }
        )
        
        
      }
    }
  }

  onContactCellClicked(_e: Event, args: any) {
    const metadata = this.contactGrid.gridService.getColumnFromEventArguments(args);

    if (metadata.columnDef.id === 'delete') {
      
      if (window.confirm('Czy potwierdzasz usunięcie kontaktu: ' + metadata.dataContext.name + '?')) {
        ContactService.deleteContact(metadata.dataContext.id).then(
          () => {
            this.contactGrid.gridService.deleteItemById(metadata.dataContext.id)

            this.setState((state: State, props: CardGridProps) => ({
              ...state,
              alertInfo: `Usunięto kontakt: ${metadata.dataContext.name}`,
            }));
        }

        ).catch(
          () => {
            this.setState((state: State, props: CardGridProps) => ({
              ...state,
              alertError: `Wystąpił problem przy usuwaniu kontaktu: ${metadata.dataContext.name}`,
            }));
          }
        )
        
        
      }
    }
  }

  checkItemIsEditable(dataContext: any, columnDef: Column, grid: SlickGrid) {
    const gridOptions = grid.getOptions() as GridOption;
    const hasEditor = columnDef.editor;
    const isGridEditable = gridOptions.editable;
    let isEditable = Boolean(isGridEditable && hasEditor);
  
    if (dataContext && columnDef && gridOptions?.editable) {
      isEditable = true //authService.isAdmin() 
    }
    return isEditable;
  }

  

  handleonAddNewRow(_e: Event, args: OnAddNewRowEventArgs) {
     //return true;
  }

  handleOnCompositeEditorChange(_e: Event, args: OnCompositeEditorChangeEventArgs) {
    
  }

  handleOnBeforeEditCell(e: Event, args: any) {
    const { column, item, grid } = args;

    if (column && item && !this.checkItemIsEditable(item, column, grid)) {
      e.stopImmediatePropagation();
      return false;
    }
    return true;
  }

  resizeContent($event:any){
 
  }



    changeTabClick(
      e: React.MouseEvent<HTMLAnchorElement> | undefined,
      value: number
    ){
      e?.preventDefault();
      localStorage.setItem(LOCAL_STORAGE_ACTIVE_TAB, JSON.stringify(value))
    
      this.defineGrids()
  }

  render() {
    if (this.state.alertWarning) {
      enqueueSnackbar(this.state.alertWarning, {variant: 'warning', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: CardGridProps) => ({
        ...state,
        alertWarning: ''
      }));
    }
    if (this.state.alertError) {
      enqueueSnackbar(this.state.alertError, {variant: 'error', preventDuplicate: true, autoHideDuration:5000, persist: false})
      this.setState((state: State, props: CardGridProps) => ({
        ...state,
        alertError: ''
      }));
    }

    if (this.state.alertInfo) {
      enqueueSnackbar(this.state.alertInfo, {variant: 'info', preventDuplicate: true, autoHideDuration:5000, persist: false}) 
      this.setState((state: State, props: CardGridProps) => ({
        ...state,
        alertInfo: ''
      }));
    }

    var activeTabIndexStr = localStorage.getItem(LOCAL_STORAGE_ACTIVE_TAB) || "1"
    var activeTabIndex = parseInt(activeTabIndexStr)
if (activeTabIndex >=1 && activeTabIndex<=5){
    var tab1ClassName =  activeTabIndex==1? "nav-link active" : 'nav-link'
    var tab2ClassName =  activeTabIndex==2? "nav-link active" : 'nav-link'
    var tab3ClassName =  activeTabIndex==3? "nav-link active" : 'nav-link'
    var tab4ClassName =  activeTabIndex==4? "nav-link active" : 'nav-link'
    var tab5ClassName =  activeTabIndex==5? "nav-link active" : 'nav-link'

    var tab1ContentClassName =  activeTabIndex==1? "tab-pane fade show active" : 'tab-pane fade show'
    var tab2ContentClassName =  activeTabIndex==2? "tab-pane fade show active" : 'tab-pane fade show'
    var tab3ContentClassName =  activeTabIndex==3? "tab-pane fade show active" : 'tab-pane fade show'
    var tab4ContentClassName =  activeTabIndex==4? "tab-pane fade show active" : 'tab-pane fade show'
    var tab5ContentClassName =  activeTabIndex==5? "tab-pane fade show active" : 'tab-pane fade show'

    
}else{
  var tab1ClassName =  "nav-link active" 
  var tab2ClassName =  'nav-link'
  var tab3ClassName =  'nav-link'
  var tab4ClassName =  'nav-link'
  var tab5ClassName =  'nav-link'

  var tab1ContentClassName =  "tab-pane fade show active"
  var tab2ContentClassName =  'tab-pane fade show'
  var tab3ContentClassName =  'tab-pane fade show'
  var tab4ContentClassName =  'tab-pane fade show'
  var tab5ContentClassName =  'tab-pane fade show'

}

    return (
       <>
         <div>
          <ul className="nav nav-tabs"
            id="myTab"
            role="tablist">
            <li className="nav-item">
              <a className={tab1ClassName}
                id="note-tab"
                data-bs-toggle="tab"
                href="#note"
                role="tab"
                aria-controls="note"
                aria-selected="true"
                onClick={ (e) => this.changeTabClick(e, 1)}
                >Notatki</a>
            </li>
            <li className="nav-item">
              <a className={tab2ClassName}
                id="contact-tab"
                data-bs-toggle="tab"
                href="#contact"
                role="tab"
                aria-controls="contact"
                aria-selected="false"
                onClick={ (e) => this.changeTabClick(e, 2)}
                >Osoby kontaktowe</a>
            </li>
            <li className="nav-item">
              <a className={tab3ClassName}
                id="invoice-tab"
                data-bs-toggle="tab"
                href="#invoice"
                role="tab"
                aria-controls="invoice"
                aria-selected="false"
                onClick={ (e) => this.changeTabClick(e, 3)}
                >Faktury</a>
            </li>
            <li className="nav-item">
              <a className={tab4ClassName}
                id="contract-tab"
                data-bs-toggle="tab"
                href="#contract"
                role="tab"
                aria-controls="contract"
                aria-selected="false"
                onClick={ (e) => this.changeTabClick(e, 4)}
              >Umowy</a>
            </li>
            <li className="nav-item">
              <a className={tab5ClassName}
                id="change-tab"
                data-bs-toggle="tab"
                href="#change"
                role="tab"
                aria-controls="change"
                aria-selected="false"
                onClick={ (e) => this.changeTabClick(e, 5)}
                >Historia zmian</a>
            </li>
          </ul>
          <div className="tab-content"
            id="NoteTabContent">
            <div className={tab1ContentClassName}
              id="note"
              role="tabpanel"
              aria-labelledby="note-tab">
               
                  <div className="gridMenu">
                    <div className='gridLeftSubMenuL'> 
                      <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEditNote} onChange={(_, data) => this.autoeditNotechange(data)}  />} label="Auto-edit" />

                      <label  style={{marginLeft:'50px'}} htmlFor="quicknotes"></label>

                          <select name="quicknotes" id="quicknotes">
                            <option value="">Wybierz typ notatki</option>
                            <option value="Klient nie odbiera">Klient nie odbiera</option>
                            <option value="SMS – oddzwonię po spotkaniu/proszę o kontakt później">SMS – oddzwonię po spotkaniu/proszę o kontakt później</option>
                            <option value="Poczta głosowa, nagrałam/em się">Poczta głosowa, nagrałam/em się</option>
                            <option value="Targi mnie nie interesują">Targi mnie nie interesują</option>
                            <option value="Czekamy na decyzję">Czekamy na decyzję</option>
                            <option value="Wystawiam umowę">Wystawiam umowę</option>
                            <option value="Działanie windykacyjne">Działanie windykacyjne</option>
                            {authService.isAdmin() ? <option value="notatka administratora">notatka administratora</option> : ""}
                          </select> 

                          <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                          onClick={() => {
                            console.log($('#quicknotes').val())
                            if ($('#quicknotes').val() == ''){
                              alert('Wybierz typ szybkiej notatki!')
                            }else{
                                notesService.addNote({contractor_id:this.contractor_id, notedef_id:11, notedef_name: "Szybka notatka", description:$('#quicknotes').val()}).then(
                                response => {
                                  this.setState((state: State, props: CardGridProps) => ({
                                    ...state,
                                    alertInfo: `Zapisano notatkę`,
                                  }));
                                  this.noteGrid.filterService.updateFilters([])
                                }
                              ).catch(
                                error => {
                                  //alert('Błąd przy dodawaniu notatki!')
                                  this.setState((state: State, props: CardGridProps) => ({
                                    ...state,
                                    alertError: `Bład przy zapisie notatki`,
                                  }));
                                }
                              )
                            }
                          }}>
                          Zapisz
                        </button>
                      
                    </div>
                    
                    
                    <div className='gridCenterSubMenuL'>
                    
                   
                   
              

                    { <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                          onClick={() => {this.openNoteCompositeModal('create')} 
                    }>
                          Dodaj
                        </button>
                    }
                  
                      
                    <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
                      onClick={() => this.openNoteCompositeModal('edit')}>
                        Edytuj
                    </button>
                      
                    </div><div className='gridRightSubMenuL'>
                        <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                          onClick={() => this.setNoteFactorySettings()}>
                          Ustawienia domyślne
                        </button>
                        <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                          onClick={() => this.cancelNoteFiltering()}>
                          Usuń Filtry
                        </button>

                      </div>
                  </div>
                  <div id="note-container" onResize={this.resizeContent} style={{ width: '100%' }}>
                  {this.state.status_note.text =='loading' ? <BorderSpinner/> : ''}
                  { !this.state.notes_gridOptions ? '' : <SlickgridReact gridId="card-note-grid"
                    columnDefinitions={this.state.notes_columnDefinitions}
                    gridOptions={this.state.notes_gridOptions}
                    dataset={this.state.notes_dataset}
                    paginationOptions={this.state.notePaginationOptions}
                    onReactGridCreated={$event => this.reactNoteGridReady($event.detail)}
                    onGridStateChanged={$event => this.gridNoteStateChanged($event.detail)}
                    onClick={e => { this.onNoteCellClicked(e.detail.eventData, e.detail.args); }}  
                    onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
                    onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
                    onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
                    onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
                    
                    
                  />
               }
                  
               </div>
            
            </div> 
         </div>  

         <div className="tab-content"
            id="ContactTabContent">
            <div className={tab2ContentClassName}
              id="contact"
              role="tabpanel"
              aria-labelledby="contact-tab">
                
                  <div className="gridMenu">
                    <div className='gridLeftSubMenu'> 
                      <FormControlLabel id="lblautoedit" control={<Switch checked={this.state.isAutoEditContact} onChange={(_, data) => this.autoeditContactchange(data)}  />} label="Auto-edit" />

                      
                    </div>
                    
                    
                    <div className='gridCenterSubMenu'>
                    
                    { <button className="btn btn-outline-secondary btn-sm mx" data-test="clear-sorting"
                          onClick={() => {this.openContactCompositeModal('create')} 
                    }>
                          Dodaj
                        </button>
                    }
                  
                      
                    <button className="btn btn-outline-secondary btn-sm mx-1" data-test="clear-sorting"
                      onClick={() => this.openContactCompositeModal('edit')}>
                        Edytuj
                    </button>
                      
                    </div><div className='gridRightSubMenu'>
                        <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                          onClick={() => this.setContactFactorySettings()}>
                          Ustawienia domyślne
                        </button>

                      </div>
                  </div>
                  <div id="contact-container" onResize={this.resizeContent} style={{ width: '100%' }}>
                  {this.state.status_contact.text =='loading' ? <BorderSpinner/> : ''}
                  { !this.state.contacts_gridOptions ? '' : <SlickgridReact gridId="card-contact-grid"
                    columnDefinitions={this.state.contacts_columnDefinitions}
                    gridOptions={this.state.contacts_gridOptions}
                    dataset={this.state.contacts_dataset}
                    paginationOptions={this.state.contactPaginationOptions}
                    onReactGridCreated={$event => this.reactContactGridReady($event.detail)}
                    onGridStateChanged={$event => this.gridContactStateChanged($event.detail)}
                    onClick={e => { this.onContactCellClicked(e.detail.eventData, e.detail.args); }}  
                    onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
                    onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
                    onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
                    onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
                    
                    
                  />
                }
                 
                 
               </div>
            </div> 
         </div>  
         <div className="tab-content"
            id="InvoiceTabContent">
            <div className={tab3ContentClassName}
              id="invoice"
              role="tabpanel"
              aria-labelledby="invoice-tab">
              To do...
            </div>    
         </div>   
         <div className="tab-content"
            id="ContractTabContent">
            <div className={tab4ContentClassName}
              id="contract"
              role="tabpanel"
              aria-labelledby="contract-tab">
            To do...
            </div>   
         </div>        


         <div className="tab-content"
            id="ChangeTabContent">
            <div className={tab5ContentClassName}
              id="change"
              role="tabpanel"
              aria-labelledby="change-tab">
                
                  <div className="gridMenu">
                    <div className='gridLeftSubMenu'> 
                      
                      
                    </div>
                    
                    
                    <div className='gridCenterSubMenu'>
                    
                    
                    </div><div className='gridRightSubMenu'>
                        <button className="btn btn-outline-secondary btn-sm mx-1" data-test="set-dynamic-sorting"
                          onClick={() => this.setChangeFactorySettings()}>
                          Ustawienia domyślne
                        </button>

                      </div>
                  </div>
                  <div id="change-container" onResize={this.resizeContent} style={{ width: '100%' }}>
                  {this.state.status_change.text =='loading' ? <BorderSpinner/> : ''}
                  { !this.state.changes_gridOptions ? '' : <SlickgridReact gridId="card-change-grid"
                    columnDefinitions={this.state.changes_columnDefinitions}
                    gridOptions={this.state.changes_gridOptions}
                    dataset={this.state.changes_dataset}
                    paginationOptions={this.state.changePaginationOptions}
                    onReactGridCreated={$event => this.reactChangeGridReady($event.detail)}
                    onGridStateChanged={$event => this.gridChangeStateChanged($event.detail)}
                    //onBeforeEditCell={$event => this.handleOnBeforeEditCell($event.detail.eventData, $event.detail.args)}   
                    //onCompositeEditorChange={$event => this.handleOnCompositeEditorChange($event.detail.eventData, $event.detail.args)}
                    //onAddNewRow={$event => this.handleonAddNewRow($event.detail.eventData, $event.detail.args)}
                    //onValidationError={e => { this.onCellValidationError(e.detail.eventData, e.detail.args); }}
                    
                    
                  />
                }
                 
                 
               </div>
            </div> 
         </div>  


       </div>   
      </>
    );
  }
}

export default withTranslation()(ContractorGrids);